// test606
(606 && 0);
